interface Props {
  title: string;
  summary?: string;
  highlightFirst?: boolean; // gold underline on first word (brand design decision)
}

export function SectionHeader({ title, summary, highlightFirst = true }: Props) {
  const words = title.split(' ');
  const first = words[0];
  const rest = words.slice(1).join(' ');

  return (
    <div className="flex items-baseline justify-between mb-4">
      <h2
        className="font-serif font-[600] text-[28px] leading-[1.2] tracking-[-0.01em]"
        style={{ fontFamily: 'var(--font-serif)', color: 'var(--color-near-black)' }}
      >
        {highlightFirst ? (
          <>
            <span className="relative">
              {first}
              <span
                className="absolute bottom-0 left-0 right-0 h-[2px] rounded-full"
                style={{ background: 'var(--color-gold)' }}
                aria-hidden
              />
            </span>
            {rest && ` ${rest}`}
          </>
        ) : (
          title
        )}
      </h2>

      {summary && (
        <span className="text-[13px] font-[500] text-[var(--color-mid-gray)] shrink-0 ml-4">
          {summary}
        </span>
      )}
    </div>
  );
}
